export default __webpack_public_path__ + "static/media/ลูกค้าสล็อตรับโบนัส10v2.71fb8879.png";